import { ActionTree } from "vuex";
import { RootState } from "../types";
import { UserState } from "./types";

export const actions: ActionTree<UserState, RootState> = {};
